import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import { VIEW_TYPE } from "containers/View/reducer";

// MarketplaceDemo
import * as marketplaceDemoReducer from "containers/MarketplaceDemo/reducer";
import { getIsMarketplaceDemo } from "containers/MarketplaceDemo/reducer";
import { getIsRecipesEnabled } from "containers/Recipe/reducer";
import { getIsModelsLegacy } from "containers/Run/reducer";
import * as globalReducer from "containers/App/reducer";
import * as loginReducer from "containers/Login/reducer";
import * as foldersReducer from "containers/Folders/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";

import FoldersMenu from "components/Folders/FoldersMenu";

import { getIsEDG } from "containers/Gallery/GalleryReducer";

import { isEnabled } from "utils/featureFlags";

class FoldersMenuContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    props.updateSearch("");
  }

  componentWillUnmount() {
    const { search, updateSearch } = this.props;
    if (search) {
      updateSearch("");
    }
  }

  render() {
    const { type, typeOptions, updateType, updateSearch, isTile, updateIsTile } = this.props;

    return <FoldersMenu {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateIsTile: (isTile) => dispatch(viewReducer.updateIsTile(isTile)),
  updateType: (type) => dispatch(viewReducer.updateType(type)),
  updateSearch: (search) => dispatch(viewReducer.updateSearch(search)),

  updateShowSettings: (val) => dispatch(chatGPTReducer.updateShowSettings(val))
});

const mapStateToProps = (state, ownProps) => {
  // MarketplaceDemo
  const showConsulting =
    marketplaceDemoReducer
      .getConsulting(state)
      .filter((elem) => elem && elem.wizard && elem.wizard.marketplace && elem.wizard.marketplace.purchased).length > 0;

  const projectsIsEnabled = showConsulting && getIsMarketplaceDemo();
  const recipesIsEnabled = getIsRecipesEnabled();
  const isTableauMode = globalReducer.getIsTableauMode(state);
  const isGoogleMode = globalReducer.getIsGoogleMode(state);

  let isLoading = {
    [VIEW_TYPE.BLUEPRINTS]: globalReducer.getIsBlueprintsLoading(state),
    [VIEW_TYPE.DATASETS]: globalReducer.getIsDatasetsLoading(state) || globalReducer.getIsArtifactsLoading(state),
    [VIEW_TYPE.RUNS]: globalReducer.getIsJobsLoading(state),
    [VIEW_TYPE.OPTIMIZERS]: globalReducer.getIsOptimizersLoading(state),
    [VIEW_TYPE.AGENT_TEMPLATES]:
      globalReducer.getIsDeploymentsLoading(state) || globalReducer.getIsBlueprintsLoading(state),
    [VIEW_TYPE.DEPLOYMENTS]:
      globalReducer.getIsDeploymentsLoading(state) || globalReducer.getIsBlueprintsLoading(state),
    [VIEW_TYPE.EXPLORATIONS]: globalReducer.getIsReportsLoading(state),
    [VIEW_TYPE.CHATS]: globalReducer.getIsReportsLoading(state),
    [VIEW_TYPE.CHAT_APPS]: globalReducer.getIsBlueprintsLoading(state),
    [VIEW_TYPE.ARTIFACTS]: globalReducer.getIsArtifactsLoading(state)
  };

  let defaultOptions =
    isEnabled("chat-aible-consumer") && !isEnabled("aible-optimize")
      ? [VIEW_TYPE.DATASETS, VIEW_TYPE.CHATS, VIEW_TYPE.CHAT_BLUEPRINTS, VIEW_TYPE.CHAT_APPS]
      : isGoogleMode
        ? [VIEW_TYPE.DATASETS]
        : isEnabled("aible-explore") || isTableauMode
          ? [VIEW_TYPE.DATASETS, VIEW_TYPE.EXPLORATIONS]
          : isEnabled("aible-consumer")
            ? [VIEW_TYPE.OPTIMIZERS, VIEW_TYPE.DATASETS, VIEW_TYPE.DEPLOYMENTS]
            : getIsEDG()
              ? [VIEW_TYPE.DATASETS, VIEW_TYPE.BLUEPRINTS, VIEW_TYPE.REPORTS]
              : [VIEW_TYPE.EXPLORATIONS, VIEW_TYPE.DATASETS, VIEW_TYPE.BLUEPRINTS, VIEW_TYPE.DEPLOYMENTS];

  let disabledViews = [];

  const shouldAddFields = !isEnabled("chat-aible-consumer");
  if (shouldAddFields) {
    if (recipesIsEnabled) {
      defaultOptions.push(VIEW_TYPE.RECIPES);
      isLoading[VIEW_TYPE.RECIPES] = globalReducer.getIsRecipesLoading(state);
    }

    if (projectsIsEnabled) {
      defaultOptions.push(VIEW_TYPE.PROJECTS);
    }

    if (getIsModelsLegacy()) {
      defaultOptions.push(VIEW_TYPE.RUNS);
    }
  }

  // add tasks as the first tab after the initial array initialization
  if (isEnabled("tasks")) {
    defaultOptions.push(VIEW_TYPE.TASKS);
  }

  if (isEnabled("chat-aible") && isEnabled("aible-optimize")) {
    if (!defaultOptions.includes(VIEW_TYPE.DEPLOYMENTS)) {
      let insertIndex = defaultOptions.indexOf(VIEW_TYPE.CHAT_BLUEPRINTS) + 1;
      if (insertIndex <= 0) {
        insertIndex = defaultOptions.length;
      }
      insertIndex = Math.max(insertIndex, 0);
      defaultOptions.splice(insertIndex, 0, VIEW_TYPE.DEPLOYMENTS);
      let deleteIndex = defaultOptions.indexOf(VIEW_TYPE.CHAT_APPS);
      if (deleteIndex >= 0) {
        defaultOptions.splice(deleteIndex, 1);
      }
    }
  } else if (isEnabled("chat-aible")) {
    if (!defaultOptions.includes(VIEW_TYPE.CHAT_APPS)) {
      let insertIndex = defaultOptions.indexOf(VIEW_TYPE.CHAT_BLUEPRINTS) + 1;
      if (insertIndex <= 0) {
        insertIndex = defaultOptions.length;
      }
      insertIndex = Math.max(insertIndex, 0);
      defaultOptions.splice(insertIndex, 0, VIEW_TYPE.CHAT_APPS);
      let deleteIndex = defaultOptions.indexOf(VIEW_TYPE.DEPLOYMENTS);
      if (deleteIndex >= 0) {
        defaultOptions.splice(deleteIndex, 1);
      }
    }
  }

  // TODO: MADNESS - this is a hack to get the new chat tab to be first
  // Removing VIEW_TYPE.EXPLORATIONS if it exists.
  const explorationsIndex = defaultOptions.indexOf(VIEW_TYPE.EXPLORATIONS);
  if (explorationsIndex !== -1) {
    defaultOptions.splice(explorationsIndex, 1);
    defaultOptions.unshift(VIEW_TYPE.EXPLORATIONS);
  }
  // Only show Agents tab if customer has chat
  if (isEnabled("chat-aible")) {
    defaultOptions.unshift(VIEW_TYPE.APPS_AGENTS);
  }
  // Insert the templates tab after projects (datasets as fallback)
  if (isEnabled("chat-aible-templates")) {
    defaultOptions.unshift(VIEW_TYPE.AGENT_TEMPLATES);
  }
  if (!isEnabled("enable-agents-templates-view")) {
    disabledViews.push(VIEW_TYPE.AGENT_TEMPLATES);
  }
  if (isEnabled("chat-aible")) {
    defaultOptions.unshift(VIEW_TYPE.NEW_CHAT);
  }

  // const IS_SIMPLE_MODE = true;

  // if (IS_SIMPLE_MODE === true) {
  //   defaultOptions = [
  //     VIEW_TYPE.NEW_CHAT,
  //     VIEW_TYPE.DATASETS,
  //     VIEW_TYPE.EXPLORATIONS,
  //     VIEW_TYPE.TEMPLATES,
  //     VIEW_TYPE.DEPLOYMENTS,
  //     VIEW_TYPE.ARTIFACTS,
  //     VIEW_TYPE.CHAT_BLUEPRINTS,
  //     VIEW_TYPE.CHAT_ANALYTICS
  //   ]
  // }

  // if(isEnabled("aible-agent")) {
  //   defaultOptions.unshift(VIEW_TYPE.AGENTS);
  // }

  const deployIndex = defaultOptions.indexOf(VIEW_TYPE.DEPLOYMENTS);
  if (deployIndex !== -1) {
    defaultOptions.splice(deployIndex, 1);
  }

  // Removing VIEW_TYPE.CHAT_APPS if it exists.
  const chatAppsIndex = defaultOptions.indexOf(VIEW_TYPE.CHAT_APPS);
  if (chatAppsIndex !== -1) {
    defaultOptions.splice(chatAppsIndex, 1);
  }

  // Only show the Organization Analytics tab if flag
  if (isEnabled("show-organization-analytics")) {
    defaultOptions.push(VIEW_TYPE.ORGANIZATION_ANALYTICS);
  }

  defaultOptions.push(VIEW_TYPE.MONITORING);

  // defaultOptions.push(VIEW_TYPE.ALL);

  // let retHideMenu = ownProps.hideMenu;
  // if (globalReducer.getIsDataMode(state)) {
  //   retHideMenu = true;
  // }
  // let retHideSearch = ownProps.hideSearch !== undefined ? ownProps.hideSearch : getIsEDG()

  // Move Models & AI Feedback to the second to last tab
  if (isEnabled("model-fine-tuning") && !defaultOptions.includes(VIEW_TYPE.ARTIFACTS)) {
    // let insertIndex = defaultOptions.indexOf(VIEW_TYPE.DEPLOYMENTS) + 1;
    // if (insertIndex <= 0) {
    //   insertIndex = defaultOptions.indexOf(VIEW_TYPE.EXPLORATIONS) + 1;
    // }
    // insertIndex = Math.max(insertIndex, 0);
    // defaultOptions.splice(insertIndex, 0, VIEW_TYPE.ARTIFACTS);
    defaultOptions.push(VIEW_TYPE.ARTIFACTS);
  }

  // Move these tabs after models & ai feedback
  //
  if (shouldAddFields) {
    if (isEnabled("dashboard-overview")) {
      defaultOptions.push(VIEW_TYPE.OVERVIEW);
    }
  }

  if (isEnabled("chat-aible") && !defaultOptions.includes(VIEW_TYPE.CHAT_BLUEPRINTS)) {
    if (isEnabled("hide-chat-blueprints") !== true) {
      defaultOptions.push(VIEW_TYPE.CHAT_BLUEPRINTS);
    }
    let deleteIndex = defaultOptions.indexOf(VIEW_TYPE.BLUEPRINTS);
    if (deleteIndex >= 0) {
      defaultOptions.splice(deleteIndex, 1);
    }
  }

  if (isEnabled("chat-analytics-view")) {
    defaultOptions.push(VIEW_TYPE.CHAT_ANALYTICS);
  }
  //
  // End of tabs moved after models & ai feedback

  if (defaultOptions.includes(VIEW_TYPE.DATASETS)) {
    let deleteIndex = defaultOptions.indexOf(VIEW_TYPE.DATASETS);
    if (deleteIndex >= 0) {
      defaultOptions.splice(deleteIndex, 1);
    }
    defaultOptions.push(VIEW_TYPE.DATASETS);
  }

  let retHideMenu = false;
  let retHideSearch = false;
  if (isGoogleMode) {
    retHideMenu = true;
    retHideSearch = true;
  }

  const viewType = viewReducer.getType(state);

  if (viewType === VIEW_TYPE.ARTIFACTS || viewType === VIEW_TYPE.NEW_CHAT || viewType === VIEW_TYPE.AGENT_TEMPLATES) {
    retHideSearch = true;
  }

  if (isEnabled("agent-autonomy-controls")) {
    const agentAutonomyView = viewReducer.getAgentAutonomyView(state);
    if (agentAutonomyView === "NONE") {
      disabledViews.push(VIEW_TYPE.NEW_CHAT);
    }
  }

  if (isEnabled("spark-agents-templates-view")) {
    defaultOptions = [VIEW_TYPE.AGENT_TEMPLATES, VIEW_TYPE.APPS_AGENTS, VIEW_TYPE.EXPLORATIONS, VIEW_TYPE.DATASETS];

    if (isEnabled("spark-with-partners")) {
      defaultOptions.unshift(VIEW_TYPE.NEW_CHAT);
    }
  }

  return {
    isTile: viewReducer.getIsTile(state),
    type: viewType,
    search: viewReducer.getSearch(state),
    fetchingDatasetCount: viewReducer.getFetchingDatasetCount(state),
    typeOptions: ownProps.typeOptions ? ownProps.typeOptions : defaultOptions,
    isLoading: isLoading,
    isSampleAccount: loginReducer.getIsSampleAccount(state),
    hideMenu: retHideMenu,
    hideSearch: retHideSearch,
    selectedFolder: foldersReducer.getSelectedFolder(state),
    isTableauMode: isTableauMode,
    showSettings: chatGPTReducer.getShowSettings(state),
    disabledViews: disabledViews
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FoldersMenuContainer);
